/* Felicitations · Quote Pricing Engine (v2 — full STD/INV/OTD/DES)
 *
 * Ported from assets/quote-calculator.js (v1) — DESIGN/STD/INV/ENVELOPES/OTD_*
 * constants and calcSTD/calcINV/calcOTD/calcDES functions adapted to read
 * state via a parameter instead of a global.
 *
 * DRIFT RULE: while v1 runs in parallel, any v1 pricing change must land here
 * in the same commit. After cutover this becomes the only source.
 *
 * Public API: window.FEL_PRICING
 *   { DESIGN, isReducedScope, getDesignFee, computeQuickEstimate,
 *     calcStd, calcInv, calcOtd, calcDes, calcAll }
 */
(function() {
  'use strict';

  // ── Tier band helpers ────────────────────────────────────────
  function tierDigital(q){ if(q<10)return 0; if(q<30)return 1; if(q<50)return 2; if(q<100)return 3; if(q<150)return 4; return 5; }
  function tierPress(q){   if(q<30)return -1; if(q<50)return 0; if(q<80)return 1; if(q<100)return 2; if(q<150)return 3; return 4; }
  function tierAcrylic(q){ if(q<10)return -1; if(q<30)return 0; if(q<50)return 1; if(q<100)return 2; if(q<150)return 3; return 4; }
  function tierOTD(q){     if(q<30)return 0; if(q<50)return 1; if(q<100)return 2; if(q<200)return 3; return 4; }

  // ── DESIGN deposit ladder ────────────────────────────────────
  var DESIGN = {
    suite:   { price: 300.00, priceReduced: 200.00, label: 'Studio Collection' },
    indiv:   { price: 500.00, priceReduced: 300.00, label: 'Tailored Touch' },
    bespoke: { price: 750.00, priceReduced: 600.00, label: 'Bespoke Design' },
    addons: {
      illust:       { price: 150.00 },
      monogram:     { price: 50.00 },
      extraRev:     { price: 75.00 },
      printReady:   { price: 150.00 },
      samplePrints: { price: 35.00 }
    }
  };

  // ── STD constants (v1 parity) ────────────────────────────────
  var STD = {
    digital: {
      base: { '100x150': [11.00, 10.00, 8.50, 7.50, 7.00, 5.50] },
      addons: {
        foilSingle: [6.00, 6.00, 6.00, 5.50, 5.50, 5.00],
        duplexing:  [7.00, 5.75, 5.00, 4.80, 4.60, 3.50],
        cutToShape: [2.50, 2.50, 2.50, 2.00, 2.00, 2.00]
      }
    },
    acrylic: {
      base: { '100x150':[21.50,17.50,17.00,16.50,13.80], '70x70':[13.00,10.90,9.20,8.70,6.90] },
      mirror: { '100x150': 3.00, '70x70': 1.50 }
    },
    letterpress: {
      base: { '100x150':[28.50,18.50,13.80,11.50,10.00] },
      addons: { secondColour: 6.00, hotFoil: 11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] }
    },
    hotfoil: {
      base: { '100x150':[32.00,27.50,22.00,19.00,15.50] },
      addons: { digital: 1.50, letterpress: 8.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] }
    },
    embossed: {
      base: { '100x150':[53.00,35.50,27.60,23.50,19.50] },
      addons: { letterpress: 8.00, hotFoil: 11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] }
    },
    ribbons: { satin: 7.00, velvet: 9.00, silk: 12.00 }
  };

  // ── INV constants (v1 parity) ────────────────────────────────
  var INV = {
    digital: {
      base: { '100x150':[11.00,10.00,8.50,7.50,7.00,5.50], '120x180':[12.00,11.50,9.50,8.00,7.50,6.00], '148x210':[12.50,12.00,10.00,8.50,8.00,6.50] },
      addons: {
        foilSingle: { '100x150':6.00, '120x180':6.50, '148x210':7.00 },
        foilDouble: { '100x150':10.00, '120x180':11.00, '148x210':12.00 },
        doubleSided:[2.50,2.50,2.50,2.00,2.00,2.00],
        duplexing:  [7.00,5.75,5.00,4.80,4.60,3.50],
        cutToShape: [2.50,2.50,2.50,2.00,2.00,2.00]
      }
    },
    acrylic: {
      base: { '100x150':[21.50,17.50,17.00,16.50,13.80], '120x180':[25.30,20.50,20.00,19.50,17.50] },
      guestNamesSetup: 195.00,
      mirror: 3.00
    },
    letterpress: {
      base: { '100x150':[28.50,18.50,13.80,11.50,10.00], '120x180':[32.00,21.30,16.70,15.00,13.00], '148x210':[34.00,23.00,18.50,16.00,14.50] },
      addons: { secondColour: 6.00, hotFoil: 11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] }
    },
    hotfoil: {
      base: { '100x150':[32.00,27.50,22.00,19.00,15.50], '120x180':[35.00,29.30,23.50,21.70,17.50], '148x210':[37.00,31.90,29.90,25.80,21.80] },
      addons: { digital: 1.50, letterpress: 8.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] }
    },
    embossed: {
      base: { '100x150':[53.00,35.50,27.60,23.50,19.50], '120x180':[55.00,36.80,28.70,24.70,20.70], '148x210':[57.00,38.00,29.90,25.80,21.90] },
      addons: { letterpress: 8.00, hotFoil: 11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] }
    },
    folded: {
      base: { '120x180':[19.00,17.80,16.70,15.50,13.80], '148x210':[20.00,19.00,18.00,17.00,16.00] },
      addons: { foilSingle: 10.00, foilDouble: 15.00 }
    },
    infoCards: {
      card1:[8.00,7.50,5.20,4.60,4.00],
      card2:[6.00,5.20,4.60,4.00,3.50],
      addons: { cutToShape:[2.50,2.50,2.00,2.00,2.00] }
    },
    accessories: {
      vellum:[7.00,6.00,5.00,4.50,4.00], vellumFoil: 7.00,
      band:[6.00,5.20,4.00,3.50,3.50],   bandFoil: 5.50,
      laserPocketSimple:[18.00,16.10,13.30,12.50,11.50],
      pocketFoilFront: 8.00, pocketFoilBoth: 13.00, paperClips: 0.70
    },
    assembly: [150.00,200.00,250.00,250.00,300.00]
  };

  // ── Envelopes (shared STD + INV) ─────────────────────────────
  var ENVELOPES = {
    upgrade: { 'C6': 0.90, '130x190': 1.40, 'C5': 1.90 },
    printing: 2.50, liner: 4.50,
    waxStampCustom: 195.00, waxAdhesive: 5.50, waxStick: 9.50,
    embossedStamp: 195.00, embossedStamping: 4.00
  };

  // ── OTD constants ────────────────────────────────────────────
  var OTD_MENUS = {
    base: {
      'flat-sm':[9.00,8.50,8.00,7.50,6.00],
      'flat-lg':[9.50,9.00,8.50,8.00,7.00],
      'round':[13.00,11.50,10.50,9.70,9.20],
      'folded':[17.00,16.20,15.60,15.00,12.50],
      'folded-a5':[17.00,16.20,15.60,15.00,12.50],
      'fabric-sm':[20.00,17.00,15.50,14.00,10.00],
      'fabric-lg':[22.00,19.00,17.00,15.00,11.00],
      'triangle':[25.00,25.00,25.00,25.00,25.00]
    },
    addons: { doubleSided: 1.70, foilSingle: 5.00, foilDouble: 7.80, cutToShape: 2.50, foldedFoilSingle: 7.00, foldedFoilDouble: 12.00, triangleFoilSingle: 11.50, paperClips: 0.70 }
  };
  var OTD_BOOKLETS = {
    base: { 'cover-only':[10.90,9.70,9.50,9.20,8.00], 'cover-matte':[14.30,13.20,12.50,12.00,11.50] },
    addons: { foil: 7.50, ribbonSatin: 7.00, ribbonVelvet: 9.00, ribbonSilk: 12.00 }
  };
  var OTD_PROGRAMS = {
    base: { 'trifold':[10.90,10.00,9.00,8.50,8.00], 'fan':[10.00,8.50,7.00,5.50,4.00] },
    addons: { foilTrifold: 7.50, foilFan: 6.00, ribbonSatin: 7.00, ribbonVelvet: 9.00, ribbonSilk: 12.00 }
  };
  var OTD_RESERVED = [5.00, 4.50, 4.20, 4.00, 3.50];
  var OTD_PLACECARDS = {
    base: {
      'flat':[5.00,4.50,4.20,4.00,3.50],
      'folded':[6.00,5.20,4.80,4.50,4.00],
      'cutshape':[7.00,6.30,6.00,5.70,5.20],
      'acrylic':[9.00,8.50,8.30,8.00,7.50],
      'coaster':[13.00,11.50,10.90,10.30,9.20],
      'tag100':[5.00,4.50,4.20,4.00,3.50],
      'tag50':[4.50,4.00,3.50,3.00,2.80],
      'glass':[6.50,5.70,5.50,5.20,4.60]
    },
    addons: { foil40_100x50: 2.80, foil44_100x50: 4.00, coasterMirror: 2.00 }
  };
  var OTD_TABLENUMBERS = {
    'card-sm':{base:10.50,type:'card',label:'Cardstock 100×150mm'},
    'card-classic':{base:11.50,type:'card',label:'Cardstock 100×200mm'},
    'card-md':{base:12.50,type:'card',label:'Cardstock 148×210mm or 120×180mm'},
    'fab-std':{base:60.00,type:'fabric',label:'Fabric 30×1m'},
    'fab-grand':{base:90.00,type:'fabric',label:'Fabric 30×1.5m'},
    'acrylic-sm':{base:34.00,type:'acrylic',label:'The Minimalist (100×150)'},
    'acrylic-md':{base:38.00,type:'acrylic',label:'The Editorial (120×180)'},
    'acrylic-lg':{base:40.00,type:'acrylic',label:'Acrylic A5'},
    cardAddons:{cut:3.00,stand:12.00,foil:8.00,dsp:1.70}, acrylicAddons:{layers:100.00}
  };
  var OTD_SIGNAGE = {
    cardstock: { 'A6':{base:15.00,cut:20.00,stand:15.00,foil:25.00}, 'A5':{base:20.00,cut:20.00,stand:15.00,foil:25.00}, 'A4':{base:30.00,cut:20.00,stand:15.00,foil:25.00}, 'A3':{base:40.00,cut:30.00,stand:null,foil:60.00} },
    board: { 'A5':{base:60.00,cut:30.00,stand:20.00,foil:30.00}, 'A4':{base:120.00,cut:30.00,stand:20.00,foil:30.00}, 'A3':{base:170.00,cut:55.00,stand:60.00,foil:100.00}, 'A2':{base:240.00,cut:55.00,stand:60.00,foil:150.00}, 'A2-long':{base:280.00,cut:55.00,stand:60.00,foil:150.00}, 'A1':{base:320.00,cut:55.00,stand:60.00,foil:150.00}, 'A1-long':{base:370.00,cut:55.00,stand:60.00,foil:150.00}, 'A0':{base:480.00,cut:55.00,stand:60.00,foil:150.00}, '800x1500':{base:575.00,cut:55.00,stand:60.00,foil:150.00}, '900x1800':{base:720.00,cut:55.00,stand:100.00,foil:200.00}, '1100x2100':{base:950.00,cut:80.00,stand:120.00,foil:200.00} },
    acrylic: { 'A6':{base:60.00,cut:null,stand:null,foil:null}, 'A5':{base:80.00,cut:30.00,stand:20.00,foil:30.00}, 'A4':{base:180.00,cut:30.00,stand:20.00,foil:30.00}, 'A3':{base:310.00,cut:55.00,stand:60.00,foil:100.00}, 'A2':{base:440.00,cut:55.00,stand:60.00,foil:150.00}, 'A2-long':{base:495.00,cut:55.00,stand:60.00,foil:150.00}, 'A1':{base:570.00,cut:55.00,stand:60.00,foil:150.00}, 'A1-long':{base:630.00,cut:55.00,stand:60.00,foil:150.00}, 'A0':{base:750.00,cut:55.00,stand:null,foil:150.00} },
    fabric: { '60-70cm_1m':{linen:300.00,satin:500.00}, '60-70cm_2m':{linen:420.00,satin:620.00}, '60-70cm_2.4m':{linen:450.00,satin:650.00}, '30-40cm_1m':{linen:150.00,satin:null}, '30-40cm_1.5m':{linen:250.00,satin:null}, '30-40cm_1.8m':{linen:300.00,satin:null} },
    fabricUp: { eyelets: 10.00, linenHemming: 200.00, loopHem: 100.00, ribbon5cmBow: 20.00 },
    rigidUp:  { dispHoles: 10.00, hangRibbon: 20.00 }
  };
  // Allowed material/size combinations per signage type (matches v1 SIGN_ALLOWED)
  var SIGN_ALLOWED = {
    'welcome':  { board:['A2-long','A1','A1-long','A0','800x1500','900x1800','1100x2100'], acrylic:['A2-long','A1','A1-long','A0'], 'fabric-linen':['60-70cm_1m','60-70cm_2m','60-70cm_2.4m'] },
    'seating':  { board:['A2-long','A1','A1-long','A0','800x1500','900x1800','1100x2100'], acrylic:['A2-long','A1','A1-long','A0'], 'fabric-linen':['60-70cm_1m','60-70cm_2m','60-70cm_2.4m'] },
    'bar':      { cardstock:['A5','A4'], board:['A5','A4','A3','A2'], acrylic:['A5','A4','A3'], 'fabric-linen-narrow':['30-40cm_1m','30-40cm_1.5m','30-40cm_1.8m'] },
    'small-c':  { cardstock:['A6','A5','A4'], board:['A5','A4'] },
    'small-r':  { cardstock:['A6','A5','A4'], board:['A5','A4'] }
  };
  var TNUM_ALLOWED = {
    cardstock: ['card-sm','card-classic','card-md'],
    fabric:    ['fab-std','fab-grand'],
    acrylic:   ['acrylic-sm','acrylic-md']
  };
  var SIZE_LABELS = {
    'A6':'A6','A5':'A5','A4':'A4','A3':'A3','A2':'A2','A2-long':'A2 Long (500×700mm)','A1':'A1 (594×841mm)','A1-long':'A1 Long (594×1000mm)','A0':'A0 (841×1189mm)',
    '800x1500':'800×1500mm','900x1800':'900×1800mm','1100x2100':'1100×2100mm',
    '60-70cm_1m':'Up to 1m long','60-70cm_2m':'Up to 2m long','60-70cm_2.4m':'Up to 2.4m long',
    '30-40cm_1m':'Up to 1m long (30-40cm wide)','30-40cm_1.5m':'Up to 1.5m long (30-40cm wide)','30-40cm_1.8m':'Up to 1.8m long (30-40cm wide)'
  };
  var OTD_VOWBOOKS = { 'a6-std':{base:45.00,foil:17.00}, 'a5-std':{base:57.00,foil:23.00}, 'a6-hm':{base:75.00,foil:null}, 'a5-hm':{base:95.00,foil:null}, ribbon: { satin: 7.00, velvet: 9.00, silk: 12.00 } };
  var OTD_GUESTBOOK = { 'a4':{base:270.00,foil:50.00}, 'a5':{base:230.00,foil:50.00} };
  var OTD_WISHINGWELL = { '300':460.00, '600':690.00 };
  var OTD_THANKYOU = { 'postcard':7.50, 'with-env':8.50, 'folded':11.00 };
  var OTD_FAVOURS = {
    base: { 'tag50':[4.50,4.00,3.50,3.00,2.80], 'tag100':[5.00,4.50,4.20,4.00,3.50] },
    addons: { foil: 2.80, cut: 2.00, ribbonSatin: 7.00, ribbonVelvet: 9.00, ribbonSilk: 12.00 }
  };

  // ── DESIGN helpers ───────────────────────────────────────────
  function isReducedScope(scope) { return scope === 'otd' || scope === 'inv-std'; }
  function getDesignFee(scope, tier) {
    var entry = DESIGN[tier];
    if (!entry) return 0;
    return isReducedScope(scope) ? entry.priceReduced : entry.price;
  }

  // ── Quick estimate (unchanged from previous) ─────────────────
  var STD_DIGITAL_100x150 = STD.digital.base['100x150'];
  var INV_DIGITAL_100x150 = INV.digital.base['100x150'];
  var INV_INFOCARD_1 = INV.infoCards.card1;
  var OTD_MENU_FLAT_SM = OTD_MENUS.base['flat-sm'];
  var SIGN_SEATING_BOARD_A1 = OTD_SIGNAGE.board['A1'].base;
  var SIGN_WELCOME_BOARD_A2L = OTD_SIGNAGE.board['A2-long'].base;
  var TABLENUM_CARD_SM = OTD_TABLENUMBERS['card-sm'].base;

  function computeQuickEstimate(scope, tier, guestCount) {
    var guests = parseInt(guestCount, 10);
    if (!scope || !tier || !guests || guests <= 0) return null;
    if (!DESIGN[tier]) return null;
    var invQty = Math.ceil(guests * 0.6);
    var menuQty = guests;
    var tableQty = Math.max(1, Math.ceil(guests / 10));
    var total = getDesignFee(scope, tier);
    if (scope === 'full') total += STD_DIGITAL_100x150[tierDigital(invQty)] * invQty;
    if (scope === 'full' || scope === 'inv-std') {
      total += INV_DIGITAL_100x150[tierDigital(invQty)] * invQty;
      total += INV_INFOCARD_1[tierOTD(invQty)] * invQty;
    }
    if (scope === 'full' || scope === 'otd') {
      total += OTD_MENU_FLAT_SM[tierOTD(menuQty)] * menuQty;
      total += SIGN_SEATING_BOARD_A1;
      total += SIGN_WELCOME_BOARD_A2L;
      total += TABLENUM_CARD_SM * tableQty;
    }
    var roundTo = function(v, step) { return Math.round(v / step) * step; };
    var anchor = roundTo(total, 50);
    return { anchor: anchor, lo: roundTo(total * 0.92, 50), hi: roundTo(total * 1.10, 50), raw: total };
  }

  // ═══════════════════════════════════════════════════════════
  // FULL detailed calculators (ported from v1 calcSTD/calcINV/calcOTD)
  // Each returns a subtotal number. Read state object passed in.
  // ═══════════════════════════════════════════════════════════

  function calcStd(state) {
    var s = state.std;
    if (!s || !s.on || s.qty <= 0) return 0;
    var q = parseInt(s.qty, 10) || 0; if (q <= 0) return 0;
    var t = tierDigital(q), tp = tierPress(q), ta = tierAcrylic(q);
    var c = s.checks || {};
    var total = 0;

    if (s.printStyle === 'acrylic') {
      if (ta < 0) return 0;
      var sz = s.acSize || '100x150';
      if (STD.acrylic.base[sz]) {
        total += STD.acrylic.base[sz][ta] * q;
        if (c.acMirror) total += STD.acrylic.mirror[sz] * q;
      }
    } else if (s.printStyle === 'digital') {
      var ad = STD.digital.addons;
      total += STD.digital.base['100x150'][t] * q;
      if (c.foilS)  total += ad.foilSingle[t] * q;
      if (c.duplex) total += ad.duplexing[t] * q;
      if (c.cut)    total += ad.cutToShape[t] * q;
    } else if (s.printStyle === 'luxpress' && tp >= 0 && s.print) {
      var pset = STD[s.print];
      if (pset) {
        total += pset.base['100x150'][tp] * q;
        if (s.print === 'letterpress') {
          if (c.lp2pms) total += pset.addons.secondColour * q;
          if (c.lpFoil) total += pset.addons.hotFoil * q;
        } else if (s.print === 'hotfoil') {
          if (c.hfDigital) total += pset.addons.digital * q;
          if (c.hfLp)      total += pset.addons.letterpress * q;
        } else if (s.print === 'embossed') {
          if (c.emLp) total += pset.addons.letterpress * q;
          if (c.emHf) total += pset.addons.hotFoil * q;
        }
        if (c.cut) total += pset.addons.cutToShape[tp] * q;
      }
    }

    // Envelopes
    if (c.envUp)    total += ENVELOPES.upgrade['C6'] * q;
    if (c.envAddr)  total += ENVELOPES.printing * q;
    if (c.envLiner) total += ENVELOPES.liner * q;
    if (c.envEmb)   total += ENVELOPES.embossedStamp + ENVELOPES.embossedStamping * q;

    // Seals
    if (c.sealWax) {
      total += ENVELOPES.waxStampCustom;
      if ((s.waxType || 'adhesive') === 'adhesive') total += ENVELOPES.waxAdhesive * q;
      else total += ENVELOPES.waxStick * Math.ceil(q / 7);
    }
    if (c.sealEmb) total += ENVELOPES.embossedStamp + ENVELOPES.embossedStamping * q;

    // Ribbon
    if (c.ribbon && s.ribbon && STD.ribbons[s.ribbon]) {
      total += STD.ribbons[s.ribbon] * q;
    }
    // Magnets are free, no contribution

    return total;
  }

  function calcInv(state, hasStd) {
    var s = state.inv;
    if (!s || !s.on) return 0;
    var assemblyOnly = s.qty <= 0 && s.checks && s.checks.assembly;
    if (s.qty <= 0 && !assemblyOnly) return 0;
    var fallbackQty = parseInt(state.guestCount, 10) || 0 || (state.std && state.std.qty) || 60;
    var effectiveQty = s.qty > 0 ? parseInt(s.qty, 10) : fallbackQty;
    var q = s.qty > 0 ? parseInt(s.qty, 10) : 0;
    var t = tierDigital(effectiveQty), tp = tierPress(effectiveQty), ta = tierAcrylic(effectiveQty), tA = tierOTD(effectiveQty);
    var size = s.size || '100x150';
    var c = s.checks || {};
    var total = 0;

    if (s.format === 'acrylic') {
      if (ta < 0) return 0;
      if (INV.acrylic.base[size]) {
        total += INV.acrylic.base[size][ta] * q;
        if (c.acMirror) total += INV.acrylic.mirror * q;
        if (c.acNames)  total += INV.acrylic.guestNamesSetup;
        // keepsake is free
      }
    } else if (s.format === 'folded') {
      var foldedKey = size === '120x180' ? '120x180' : '148x210';
      if (INV.folded.base[foldedKey]) {
        total += INV.folded.base[foldedKey][tA] * q;
        if (c.foldFoilS) total += INV.folded.addons.foilSingle * q;
        if (c.foldFoilD) total += INV.folded.addons.foilDouble * q;
      }
    } else if (s.printStyle === 'digital') {
      var ad = INV.digital.addons;
      total += INV.digital.base[size][t] * q;
      if (c.dsp)    total += ad.doubleSided[t] * q;
      if (c.foilS)  total += (ad.foilSingle[size] || 0) * q;
      if (c.duplex) total += ad.duplexing[t] * q;
    } else if (s.printStyle === 'luxpress' && tp >= 0 && s.print) {
      var pset = INV[s.print];
      if (pset && pset.base[size]) {
        total += pset.base[size][tp] * q;
        if (s.print === 'letterpress') {
          if (c.lp2pms) total += pset.addons.secondColour * q;
          if (c.lpFoil) total += pset.addons.hotFoil * q;
        } else if (s.print === 'hotfoil') {
          if (c.hfDigital) total += pset.addons.digital * q;
          if (c.hfLp)      total += pset.addons.letterpress * q;
        } else if (s.print === 'embossed') {
          if (c.emLp) total += pset.addons.letterpress * q;
          if (c.emHf) total += pset.addons.hotFoil * q;
        }
      }
    }

    // Info cards
    if (s.infoCards >= 1) total += INV.infoCards.card1[tA] * q;
    if (s.infoCards >= 2) total += INV.infoCards.card2[tA] * q;

    // Shape Suite (cut to shape) enum 0..4
    var shape = s.shapeSuite || 0;
    var cutInvite = (shape === 1 || shape === 4);
    var cutInfo1 = (shape === 2 || shape === 3 || shape === 4);
    var cutInfo2 = ((shape === 3 || shape === 4) && s.infoCards === 2);
    if (cutInvite) {
      var cutPer;
      if (s.format === 'folded')                              cutPer = INV.digital.addons.cutToShape[t];
      else if (s.printStyle === 'digital')                    cutPer = INV.digital.addons.cutToShape[t];
      else if (tp >= 0 && INV[s.print])                       cutPer = INV[s.print].addons.cutToShape[tp];
      else                                                    cutPer = 2.00;
      total += cutPer * q;
    }
    if (cutInfo1 && s.infoCards >= 1) total += INV.infoCards.addons.cutToShape[tA] * q;
    if (cutInfo2 && s.infoCards >= 2) total += INV.infoCards.addons.cutToShape[tA] * q;

    // Accessories
    if (c.vellum) {
      total += INV.accessories.vellum[tA] * q;
      if (c.vellumFoil) total += INV.accessories.vellumFoil * q;
    }
    if (c.band) {
      total += INV.accessories.band[tA] * q;
      if (c.bandFoil) total += INV.accessories.bandFoil * q;
    }
    if (c.pockets) {
      total += INV.accessories.laserPocketSimple[tA] * q;
    }
    if (c.clips) total += INV.accessories.paperClips * q;

    // Envelopes (size-aware)
    if (c.envUp) {
      var envKey = size === '148x210' ? 'C5' : size === '120x180' ? '130x190' : 'C6';
      total += ENVELOPES.upgrade[envKey] * q;
    }
    if (c.envAddr)  total += ENVELOPES.printing * q;
    if (c.envLiner) total += ENVELOPES.liner * q;
    // Envelope embossing: $195 stamp is one-off — skip if STD already charging for it
    var stdActuallyCharging = hasStd && state.std && (parseInt(state.std.qty, 10) || 0) > 0;
    var stdHasEnvEmb = stdActuallyCharging && state.std.checks && state.std.checks.envEmb;
    if (c.envEmb) {
      if (!stdHasEnvEmb) total += ENVELOPES.embossedStamp;
      total += ENVELOPES.embossedStamping * q;
    }

    // Seals (skip wax stamp if STD already charging for one)
    var stdHasWax = stdActuallyCharging && state.std.checks && state.std.checks.sealWax;
    if (c.sealWax) {
      if (!stdHasWax) total += ENVELOPES.waxStampCustom;
      if ((s.waxType || 'adhesive') === 'adhesive') total += ENVELOPES.waxAdhesive * q;
      else total += ENVELOPES.waxStick * Math.ceil(q / 7);
    }
    var stdHasEmb = stdActuallyCharging && state.std.checks && state.std.checks.sealEmb;
    if (c.sealEmb) {
      if (!stdHasEmb) total += ENVELOPES.embossedStamp;
      total += ENVELOPES.embossedStamping * q;
    }

    // Ribbon
    if (c.ribbon && s.ribbon && STD.ribbons[s.ribbon]) total += STD.ribbons[s.ribbon] * q;

    // Assembly
    if (c.assembly) total += INV.assembly[tA];

    return total;
  }

  // ── OTD per-item calc ────────────────────────────────────────
  function calcOtdItem(id, it) {
    var q = parseInt(it.qty, 10) || 0;
    var total = 0;
    var ups = it.ups || {};

    if (id === 'menus' && it.format && q > 0) {
      var menuBase = OTD_MENUS.base[it.format];
      if (!menuBase) return 0;
      var tA = tierOTD(q);
      total += menuBase[tA] * q;
      var ma = OTD_MENUS.addons;
      var rect = ['flat-sm','flat-lg','folded','folded-a5'].indexOf(it.format) >= 0;
      var isFolded = it.format === 'folded' || it.format === 'folded-a5';
      var isMenuFabric = it.format === 'fabric-sm' || it.format === 'fabric-lg';
      if (ups.dsp && rect)     total += ma.doubleSided * q;
      // Foil + cut not available for fabric menus — guard even if state has stale flag
      if (ups.foil && !isMenuFabric) {
        if (isFolded)          total += ma.foldedFoilSingle * q;
        else if (it.format === 'triangle') total += ma.triangleFoilSingle * q;
        else                   total += ma.foilSingle * q;
      }
      if (ups.cut && !isMenuFabric) total += ma.cutToShape * q;
      if (it.ribbon && it.ribbon !== 'none') {
        var rp = { satin: 7, velvet: 9, silk: 12 }[it.ribbon];
        if (rp) total += rp * q;
      }
    } else if (id === 'place' && it.format && q > 0) {
      var pcBase = OTD_PLACECARDS.base[it.format];
      if (!pcBase) return 0;
      var tA2 = tierOTD(q);
      total += pcBase[tA2] * q;
      if (it.format === 'coaster' && ups.mirror) total += OTD_PLACECARDS.addons.coasterMirror * q;
      else if (ups.foil) total += OTD_PLACECARDS.addons.foil40_100x50 * q;
    } else if (id === 'service' && it.format && q > 0) {
      // Order of service — booklets (cover-*) or programs (trifold/fan)
      var tA = tierOTD(q);
      var isBooklet = it.format && it.format.indexOf('cover-') === 0;
      if (isBooklet) {
        var bk = OTD_BOOKLETS.base[it.format]; if (!bk) return 0;
        total += bk[tA] * q;
        var ba = OTD_BOOKLETS.addons;
        if (ups.foil) total += ba.foil * q;
        if (it.ribbon && it.ribbon !== 'none') {
          var rb = { satin: ba.ribbonSatin, velvet: ba.ribbonVelvet, silk: ba.ribbonSilk }[it.ribbon];
          if (rb) total += rb * q;
        }
      } else {
        var pg = OTD_PROGRAMS.base[it.format]; if (!pg) return 0;
        total += pg[tA] * q;
        var pa = OTD_PROGRAMS.addons;
        if (ups.foil) total += (it.format === 'trifold' ? pa.foilTrifold : pa.foilFan) * q;
        if (it.ribbon && it.ribbon !== 'none') {
          var rb2 = { satin: pa.ribbonSatin, velvet: pa.ribbonVelvet, silk: pa.ribbonSilk }[it.ribbon];
          if (rb2) total += rb2 * q;
        }
      }
    } else if (id === 'reserved' && q > 0) {
      total += OTD_RESERVED[tierOTD(q)] * q;
    } else if (id === 'decals' || id === 'custom') {
      // Always TBQ — no contribution to total, flagged separately by caller
      total += 0;
    } else if (id === 'tablenum' && it.format && q > 0) {
      var entry = OTD_TABLENUMBERS[it.format];
      if (!entry) return 0;
      total += entry.base * q;
      if (entry.type === 'card') {
        var ca = OTD_TABLENUMBERS.cardAddons;
        if (ups.cut)   total += ca.cut * q;
        if (ups.dsp)   total += ca.dsp * q;
        if (ups.foil)  total += ca.foil * q;
        if (ups.stand) total += ca.stand * q;
      } else if (entry.type === 'acrylic') {
        if (ups.layers) total += OTD_TABLENUMBERS.acrylicAddons.layers;
      }
    } else if (id === 'vows' && it.style) {
      var e = OTD_VOWBOOKS[it.style];
      if (!e) return 0;
      total += e.base;
      if (ups.foil && e.foil) total += e.foil;
      if (it.ribbon && it.ribbon !== 'none') {
        var rp2 = OTD_VOWBOOKS.ribbon[it.ribbon];
        if (rp2) total += rp2;
      }
    } else if (['welcome','seating','bar','small-c','small-r'].indexOf(id) >= 0) {
      if (!it.material || !it.size) return 0;
      var price = 0;
      if (it.material === 'cardstock' && OTD_SIGNAGE.cardstock[it.size])      price = OTD_SIGNAGE.cardstock[it.size].base;
      else if (it.material === 'board' && OTD_SIGNAGE.board[it.size])         price = OTD_SIGNAGE.board[it.size].base;
      else if (it.material === 'acrylic' && OTD_SIGNAGE.acrylic[it.size])     price = OTD_SIGNAGE.acrylic[it.size].base;
      else if (it.material.indexOf('fabric') >= 0) {
        var fk = it.material.indexOf('satin') >= 0 ? 'satin' : 'linen';
        var fe = OTD_SIGNAGE.fabric[it.size];
        if (fe && fe[fk]) price = fe[fk];
      }
      var smallQty = (id === 'small-c' || id === 'small-r') ? Math.max(1, parseInt(it.qty, 10) || 1) : 1;
      total += price * smallQty;
      if (['cardstock','board','acrylic'].indexOf(it.material) >= 0) {
        var src = OTD_SIGNAGE[it.material][it.size] || {};
        if (ups.cut && src.cut)     total += src.cut;
        if (ups.stand && src.stand) total += src.stand;
        if (ups.foil && src.foil)   total += src.foil;
        // Welcome/seating extras for board+acrylic — hanging hardware
        if ((id === 'welcome' || id === 'seating') && (it.material === 'board' || it.material === 'acrylic')) {
          var ru = OTD_SIGNAGE.rigidUp;
          if (ups.dispHoles)  total += ru.dispHoles;
          if (ups.hangRibbon) total += ru.hangRibbon;
        }
      } else if (it.material.indexOf('fabric') >= 0) {
        var fu = OTD_SIGNAGE.fabricUp;
        if (ups.eyelets) total += fu.eyelets;
        if (ups.hemming) total += fu.linenHemming;
        if (ups.loopHem) total += fu.loopHem;
        if (ups.ribbon)  total += fu.ribbon5cmBow;
      }
    } else if (id === 'favour' && it.format && q > 0) {
      var fb = OTD_FAVOURS.base[it.format];
      if (!fb) return 0;
      var tA3 = tierOTD(q);
      total += fb[tA3] * q;
      var fa = OTD_FAVOURS.addons;
      if (ups.foil) total += fa.foil * q;
      if (ups.cut)  total += fa.cut * q;
      if (it.ribbon && it.ribbon !== 'none') {
        var rp3 = { satin: fa.ribbonSatin, velvet: fa.ribbonVelvet, silk: fa.ribbonSilk }[it.ribbon];
        if (rp3) total += rp3 * q;
      }
    } else if (id === 'guestbook' && it.format) {
      var gb = OTD_GUESTBOOK[it.format];
      if (!gb) return 0;
      total += gb.base;
      if (ups.foil) total += gb.foil;
    } else if (id === 'wishwell' && it.format) {
      var w = OTD_WISHINGWELL[it.format];
      if (w) total += w;
    } else if (id === 'thankyou' && it.format && q > 0) {
      var ty = OTD_THANKYOU[it.format];
      if (ty) total += ty * q;
    }

    return total;
  }

  function calcOtd(state) {
    if (!state.otd || !state.otd.on) return 0;
    var total = 0;
    var items = state.otd.items || {};
    Object.keys(items).forEach(function(id) {
      var it = items[id];
      if (!it || !it.on) return;
      total += calcOtdItem(id, it);
    });
    return total;
  }

  function calcDes(state) {
    if (!state.des || !state.des.type) return 0;
    var total = getDesignFee(state.selectedCategory, state.des.type);
    var c = state.des.checks || {};
    // Monogram is INCLUDED in Tailored Touch (indiv) — skip charging even if checked
    if (c.illust)       total += DESIGN.addons.illust.price;
    if (c.monogram && state.des.type !== 'indiv') total += DESIGN.addons.monogram.price;
    if (c.extraRev)     total += DESIGN.addons.extraRev.price;
    if (c.printReady)   total += DESIGN.addons.printReady.price;
    if (c.samplePrints) total += DESIGN.addons.samplePrints.price;
    return total;
  }

  function calcAll(state) {
    var hasStd = !!(state.std && state.std.on);
    var std = calcStd(state);
    var inv = calcInv(state, hasStd);
    var otd = calcOtd(state);
    var des = calcDes(state);
    return { std: std, inv: inv, otd: otd, des: des, total: std + inv + otd + des };
  }

  window.FEL_PRICING = {
    DESIGN: DESIGN,
    STD: STD,
    INV: INV,
    ENVELOPES: ENVELOPES,
    OTD_SIGNAGE: OTD_SIGNAGE,
    OTD_MENUS: OTD_MENUS,
    OTD_PLACECARDS: OTD_PLACECARDS,
    OTD_TABLENUMBERS: OTD_TABLENUMBERS,
    OTD_VOWBOOKS: OTD_VOWBOOKS,
    OTD_GUESTBOOK: OTD_GUESTBOOK,
    OTD_WISHINGWELL: OTD_WISHINGWELL,
    OTD_THANKYOU: OTD_THANKYOU,
    OTD_FAVOURS: OTD_FAVOURS,
    OTD_BOOKLETS: OTD_BOOKLETS,
    OTD_PROGRAMS: OTD_PROGRAMS,
    SIGN_ALLOWED: SIGN_ALLOWED,
    SIZE_LABELS: SIZE_LABELS,
    tierDigital: tierDigital,
    tierPress: tierPress,
    tierAcrylic: tierAcrylic,
    tierOTD: tierOTD,
    isReducedScope: isReducedScope,
    getDesignFee: getDesignFee,
    computeQuickEstimate: computeQuickEstimate,
    calcStd: calcStd,
    calcInv: calcInv,
    calcOtd: calcOtd,
    calcDes: calcDes,
    calcAll: calcAll,
    _tierDigital: tierDigital,
    _tierOTD: tierOTD,
    _tierPress: tierPress,
    _tierAcrylic: tierAcrylic
  };
})();
